import type { Contact } from '@/src/types/listingDetails.type';

type V3ContactForm = {
  confirmationMessage?: string;
  defaultInquiryMessage?: string;
  displayContactBox?: boolean;
  message?: string;
  requiredFields?: Array<string>;
  restricted?: boolean;
};

export function normalizeV3Contact(contact: V3ContactForm | null | undefined): Contact {
  const requiredFields = contact?.requiredFields ?? [];

  return {
    restricted: Boolean(contact?.restricted),
    defaultInquiryMessage: contact?.defaultInquiryMessage ?? '',
    requiresNumBeds: requiredFields.includes('numBeds'),
    requiresMoveDate: requiredFields.includes('moveDate'),
    requiresPhone: requiredFields.includes('phone'),
    requiresName: requiredFields.includes('name') || requiredFields.includes('firstAndLastName'),
    requiresEmail: requiredFields.includes('email'),
    requiresMessage: requiredFields.includes('message'),
    displayContactBox: contact?.displayContactBox !== false,
    message: contact?.message ?? '',
    confirmationMessage: contact?.confirmationMessage ?? '',
    restrictedIncomeByOccupants: {},
  };
}
